import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: "/common/regions", params });
